import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { Campaign2Service } from './../../../services/campaign-2.0/campaign2.service';
import { Component, OnInit } from '@angular/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-campaign-list2',
  templateUrl: './campaign-list2.component.html',
  styleUrls: ['./campaign-list2.component.css', '../coupon-setup.scss']
})
export class CampaignList2Component implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  noFilter = KontableComponent.NoFilter;
  numberFilter = KontableComponent.NumberFilter;
  dateFilter = KontableComponent.DateFilter;
  showActionsPopUp: boolean;
  showDuplicateActionsPopUp: boolean;
  showMsgInfoDuplicateActionsPopUp: boolean;
  showResources: boolean;
  campaignId: number;
  campaignName: string;
  campaignAction;
  showInfoGenerationCoupon: boolean;
  invalidSubmit = false;
  newCampaignId: number;
  campaignList: SelectItem[] = [];
  campaignActionList: SelectItem[] = [];
  selectedCampaign: any;
  selectedCampaignAction: any;
  isCampaignPresent = false;
  showActionGenerated: boolean;
  viewActionGenerated: any;
  dynamicCoupon: string;
  actionStatus: string;
  cardHolderType: string;
  name: string = "";
  touchPointOfflineList: SelectItem[] = [];
  touchPointOnlineList: SelectItem[] = [];
  isBasketPresent = false;
  isMessageInstancePresent = false;
  isMessageInstanceConstraintPresent = false;
  isCampaignConstraintExclusionPresent = false;
  isCampaignConstraintValidationPresent = false;

  constructor(
    public campaign2Service: Campaign2Service,
    private router: Router,
    public calendarTranslateService: CalendarTranslateService,
    private messageService: MessageService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    this.isCampaignPresent = false;
    const campaignId = sessionStorage.getItem('campaignId');
    const campaignName = sessionStorage.getItem('campaignName');
    if (campaignId && campaignName) {
      this.openPopUpActions(+campaignId, campaignName);
    }
  }

  createCampaign(){
    if (sessionStorage.getItem('campaignId') && sessionStorage.getItem('campaignName')) {
      sessionStorage.removeItem('campaignId');
      sessionStorage.removeItem('campaignName');
    }
    this.router.navigate(['campaign-detail-2']);
  }

  createCampaignAction(){
    this.router.navigate([`campaign-action-setup/${this.campaignId}`, {campaignName: this.campaignName}]);
  }

  getR(){}

  openPopUpDuplicateActions(){
    this.showDuplicateActionsPopUp = true;
    this.getCampaignList();
  }

  openPopUpMsgInfoDuplicateActions(){
    this.showMsgInfoDuplicateActionsPopUp = true;
  }

  openPopUpActions(id: number, name: string){
    this.showActionsPopUp = true;
    this.campaignId = id;
    this.campaignName = name;
    sessionStorage.setItem('campaignId', id.toString());
    sessionStorage.setItem('campaignName', name);
    this.campaign2Service.getCampaignAction(id).subscribe(res => this.campaignAction = res);
  }


  openActionGenerated(action) {
    this.campaign2Service.viewCampaignAction(action.campaign_id, action.message_instance_id, action.id).subscribe(res=>{
      this.viewActionGenerated = res;
      this.checkActionGenerated();

      this.viewActionGenerated.touchpointDto.forEach(touchpoint => {
        if(touchpoint.flg_offline === 0) {
          this.touchPointOfflineList.push({label: touchpoint.description, value: touchpoint.id})
        } else {
          this.touchPointOnlineList.push({label: touchpoint.description, value: touchpoint.id})
        }

      })

      if(this.isMessageInstancePresent) {
        this.dynamicCoupon = this.viewActionGenerated.messageInstanceDto[0].flg_couponing_method === "D" ? this.translate.instant('shoppingList.yes'): this.translate.instant('shoppingList.no');
        this.actionStatus =  this.viewActionGenerated.messageInstanceDto[0].flg_kf === "1" ? this.translate.instant('campaign.actionDeployed'): this.translate.instant('campaign.actionNotDeployed')
        if(this.viewActionGenerated.messageInstanceDto[0].card_holder_type != null) {
          this.cardHolderType = this.viewActionGenerated.messageInstanceDto[0].card_holder_type === "S" ? this.translate.instant('campaign.specific'): this.translate.instant('campaign.generic');
        }
      }

      this.showActionGenerated = true;

    });

  }

  refreshCampaignActionList() {
    this.campaign2Service.getCampaignAction(this.campaignId).subscribe(res => this.campaignAction = res);
  }

  closePopUpAction() {
    this.showActionsPopUp = false;
    this.campaignId = null;
    this.campaignName = null;
    this.campaignAction = null;
  }

  closePopUpDuplicateAction(){
    this.showDuplicateActionsPopUp = false;
    this.clearPopUpDuplicate();
    this.refreshCampaignActionList();
  }
  
  closePopUpMsgInfoDuplicateAction(){
    this.showMsgInfoDuplicateActionsPopUp = false;
    this.showDuplicateActionsPopUp = false;
    this.clearPopUpDuplicate();
    this.refreshCampaignActionList();
  }

  closePopUpViewActionGenerated() {
    this.showActionGenerated = false;
    this.viewActionGenerated = null;
    this.touchPointOfflineList = [];
    this.touchPointOnlineList = [];
    this.dynamicCoupon = null;
    this.actionStatus = null;
    this.cardHolderType = null;
    this.isBasketPresent = false;
    this.isMessageInstancePresent = false;
    this.isMessageInstanceConstraintPresent = false;
    this.isCampaignConstraintExclusionPresent = false;
    this.isCampaignConstraintValidationPresent = false;
  }

  viewAction(action: any){
    if (action.campaign_action_status_id === 3 || action.campaign_action_status_id === 9) {
      this.router.navigate([`campaign-coupon-emission-setup/${this.campaignId}/${action.id}`, {
        actionTypeCode: action.action_type_description === 'Messaggio' ? 'MSG' : 'CPN'
      }]);
    }
    else if (action.campaign_action_status_id === 4) {
      if (action.action_type_description === 'Messaggio') {
        this.router.navigate([`campaign-coupon-layout-setup/${action.message_instance_id}/${action.id}`, {
          actionTypeCode: 'MSG'
        }]);
      } else {
        this.router.navigate(['campaign-coupon-parameters-setup/' + action.message_instance_id, {
          actionTypeCode: 'CPN'
        }]);
      }
    }
    else if (action.campaign_action_status_id === 5) {
      if (action.action_type_code === 'MSG') {
        this.router.navigate([`campaign-coupon-layout-setup/${action.message_instance_id}/${action.id}`, {
          actionTypeCode: 'MSG'
        }]);
      } else {
        this.router.navigate([`campaign-coupon-fruition-setup/${action.message_instance_id}/${action.id}`, {
          actionTypeCode: 'CPN'
        }]);
      }
    } else if (action.campaign_action_status_id === 6) {
      this.router.navigate([`campaign-coupon-layout-setup/${action.message_instance_id}/${action.id}`, {
        actionTypeCode: action.action_type_description === 'Messaggio' ? 'MSG' : 'CPN'
      }]);
    }
  }

  deleteAction(action: any) {

    /*
    eliminato if vedi KS-3843
    if (action.flg_couponing_method === 'S'&& action.actual_generated_coupon != null && action.actual_generated_coupon > 0) {
      this.confirmationService.confirm({
        header: this.translate.instant('campaign.confirmDeleteActionHeader'),
        message: this.translate.instant('campaign.actionNotDisposableMessage'),
        acceptLabel: "OK",
        rejectVisible: false
      });
    } else*/
     {
      this.confirmationService.confirm({
        header: this.translate.instant('campaign.confirmDeleteActionHeader'),
        message: this.translate.instant('campaign.confirmDeleteActionMessage'),
        accept: () =>  this.campaign2Service.deleteAction(action.id).subscribe( () =>  {
          this.messageService.add({severity: 'success', summary: 'Success', detail: this.translate.instant('campaign.campaignActionDeleted') });
          this.campaign2Service.getCampaignAction(action.campaign_id).subscribe( res => {this.campaignAction = res; console.log(this.campaignAction);});
        }),
        acceptLabel: this.translate.instant('common.confirm'),
        rejectLabel: this.translate.instant('common.cancel')
      });
    }
  }

  openPopUpResources(){
    this.showResources = true;
  }

  editCampaign(id){
    this.router.navigate([`campaign-detail-2/${id}`]);
  }

  generateCoupon(action: any) {
    const data = {
      campaign_id: action.campaign_id,
      message_instance_id: action.message_instance_id,
      action_type_code: action.action_type_code
    };
    this.campaign2Service.generateCoupon(data).subscribe(() => this.campaign2Service.getCampaignAction(action.campaign_id).subscribe( res => {
      let msg: any;
      if(data.action_type_code==='CPN')
      msg = 'campaign.infoGenerationCouponMessage';
      else
      msg = 'campaign.infoGenerationMessageMessage';
      this.campaignAction = res;
      this.confirmationService.confirm({
        header: this.translate.instant('campaign.infoGenerationCouponHeader'),
        message: this.translate.instant(msg),
        acceptLabel: 'Ok',
        rejectVisible: false
      });
    }));
  }

  confirmPublish(action: any) {
    const data = {
      campaign_id: action.campaign_id,
      message_instance_id: action.message_instance_id,
      action_type_code: action.action_type_code
    };
    if (action.flg_couponing_method === 'D') {
      this.publish(data);
      return;
    }
    this.campaign2Service.distributionListCount(data).subscribe(res => {
      let msg: any;
      if(data.action_type_code==='CPN')
      msg = 'campaign.confirmPublishMsg';
      else
      msg = 'campaign.confirmPublishMsgMessage';
      this.confirmationService.confirm({
        header: this.translate.instant('campaign.confirmPublishHeader'),
        message: this.translate.instant(msg, {customerCount: res.customer_count}),
        acceptLabel: 'Ok',
        accept: () => this.publish(data),
        rejectVisible: true
      });
    });
  }

  publish(data: any) {
    this.campaign2Service.publish(data).subscribe(() => {
      let msg: any;
      if(data.action_type_code==='CPN')
      msg = 'campaign.infoGenerationCouponMessage';
      else
      msg = 'campaign.infoGenerationMessageMessage';
      this.confirmationService.confirm({
        header: this.translate.instant('campaign.infoGenerationCouponHeader'),
        message: this.translate.instant(msg),
        acceptLabel: 'Ok',
        accept: () => this.refreshCampaignActionList(),
        rejectVisible: false
      });
    })
  }

  confirmPreview(action: any) {
    this.confirmationService.confirm({
      header: this.translate.instant('campaign.confirmPreviewHeader'),
      message: this.translate.instant('campaign.confirmPreviewMessage'),
      acceptLabel: 'Ok',
      accept: () => this.preview(action)
    });
    ;
  }

  preview(action: any) {
    this.campaign2Service.preview(action.message_instance_id, action.campaign_id).subscribe(() => {
      let msg: any;
      if(action.action_type_code==='CPN')
      msg = 'campaign.infoGenerationPreviewCouponMessage';
      else
      msg = 'campaign.infoGenerationPreviewMessage';
      this.confirmationService.confirm({
        header: this.translate.instant('campaign.infoGenerationCouponHeader'),
        message: this.translate.instant(msg),
        acceptLabel: 'Ok',
        accept: () => this.refreshCampaignActionList(),
        rejectVisible: false
      });
    })
  }

  getCampaignList() {
    this.campaignList = [{label: '', value: null}];
    this.campaign2Service.getCampaignList().subscribe(res => {
      res.forEach(campaign => this.campaignList.push({label: campaign.name, value: campaign.id}));
    })
  }

  getCampaignActionList() {
    this.campaignActionList = [{label: '', value: null}];
    this.campaign2Service.getCampaignAction(this.campaignId).subscribe(res => {
      res.forEach(campaignAction => this.campaignActionList.push({label: campaignAction.name, value: campaignAction.id}));
    })
  }

  onSelectCampaign(event) {
    this.isCampaignPresent = true;
    this.newCampaignId = event.id;
  }

  onSelectCampaignAction(event) {
    this.newCampaignId = event.id;
  }

  clearPopUpDuplicate() {
    this.name = "";
    this.selectedCampaign = null;
    this.selectedCampaignAction = null;
    this.isCampaignPresent = false;
  }

  duplicateCampaignAction(data: any) {
    const barcodeData = {
      start_emission_date: data.start_date_emission,
      end_emission_date: data.end_date_emission
    };
    let acmExist = false;
    this.campaign2Service.checkBarcodeAvailability(data.idCampaignTo, data.barcode, data.messageInstanceId, barcodeData).subscribe(() => {
      this.campaign2Service.getCampaignAcmList(data.messageInstanceId).subscribe(res=>{
        if (res != null && res.length > 0) {
          acmExist = true;
        }
      });
      this.campaign2Service.duplicateCampaignAction(data).subscribe(res => {
        console.log(acmExist)
        //acm_copy è 0 se sono stati copiati tutti gli acm - 1 se non sono stati copiati tutti - 2 se non ci sono acm collegati alla message instance
        if(res != undefined && res.acm_copy != undefined && res.acm_copy == 1 || acmExist == true)
          this.openPopUpMsgInfoDuplicateActions()
        else 
          this.closePopUpDuplicateAction()
      });
    })
  }

  checkActionGenerated() {
    if(this.viewActionGenerated.basketDto != null) {
      this.isBasketPresent = true;
    }
    if(this.viewActionGenerated.messageInstanceDto != null) {
      this.isMessageInstancePresent = true;
    }

    if(this.viewActionGenerated.messageInstanceConstraintDto != null) {
      this.isMessageInstanceConstraintPresent = true;
    }

    if(this.viewActionGenerated.campaignConstraintEsclusionDto != null) {
      this.isCampaignConstraintExclusionPresent = true;
    }

    if(this.viewActionGenerated.campaignConstraintValidationDto != null) {
      this.isCampaignConstraintValidationPresent = true;
    }
  }

  showCoupon(action: any) {
    this.router.navigate([`coupon-list/${action.message_instance_id}`]);
  }

  deployAction(message_instance_id: number) {
    this.campaign2Service.deployAction(message_instance_id).subscribe(res => {
      this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'
      });
      this.showActionsPopUp = false
    })
    ;
  }


}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-list2/campaign-list2.component.ts